import {Component, Input, OnInit} from '@angular/core';
import {Location} from "@angular/common";
import {NewsService} from "../../services/news.service";
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {

  @Input('title') title: string;
  @Input('description') description: string;
  @Input('image') image: string;
  @Input('id') id: string;
  @Input('fecha') fecha: Date;
  months: any = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
  fecha_pub: any = {day: '', month: '', year: ''};
  domain:string;
  constructor(private news: NewsService,private location: Location) {


  }

  ngOnInit() {

    this.fecha = new Date(this.fecha);
    this.fecha_pub.day = this.fecha.getDate();
    this.fecha_pub.month = this.fecha.getMonth();
    this.fecha_pub.year = this.fecha.getFullYear();
    this.news.getConfig().subscribe(response => {
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
  }
  link() {
    location.href = '/noticia/' + this.id;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/news/news.component.ts